const chatHistory = [
    {
        name: 'user',
        message: 'Hello',
        time: '23:29 pm'
    },
    {
        name: 'user',
        message: 'Hello',
        time: '23:29 pm'
    },
    {
        name: 'admin',
        message: 'Hello',
        time: '23:29 pm'
    },
    {
        name: 'user',
        message: 'Hello',
        time: '23:29 pm'
    },
    {
        name: 'user',
        message: 'Hello',
        time: '23:29 pm'
    },
    {
        name: 'user',
        message: 'Hello',
        time: '23:29 pm'
    },
    {
        name: 'user',
        message: 'Hello',
        time: '23:29 pm'
    },
    {
        name: 'user',
        message: 'Hello',
        time: '23:29 pm'
    },
    {
        name: 'user',
        message: 'Hello',
        time: '23:29 pm'
    },
    {
        name: 'user',
        message: 'Hello',
        time: '23:29 pm'
    },

]

export default chatHistory;